import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import {
  FooterBox,
  StyledPaper,
  StyledTableCellHead,
  StyledTableHead,
} from "./style";

export default function VirtualLockerTable({
  columns = [],
  rows = [],
  columnKeys = [],
  selectedTab = 0,
  tabLabels = [],
}) {
  const keys =
    columnKeys.length > 0
      ? columnKeys
      : ["orderId", "locker_id", "customer_name", "expiry_date", "items_count", "status"];

  return (
    <StyledPaper tabLabel={tabLabels[selectedTab]}>
      <TableContainer>
        <Table>
          <StyledTableHead tabLabel={tabLabels[selectedTab]}>
            <TableRow>
              {columns.map((col) => (
                <StyledTableCellHead key={col}>{col}</StyledTableCellHead>
              ))}
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  <Typography>No records found</Typography>
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row, idx) => (
                <TableRow key={row.id ?? idx}>
                  {keys.map((key) => (
                    <TableCell key={key}>
                      {key === "orderId" ? (
                        <Typography color="primary" fontWeight={500}>
                          {row[key]}
                        </Typography>
                      ) : (
                        row[key]
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <FooterBox>
        <Typography variant="body2">Showing {rows.length} results</Typography>
      </FooterBox>
    </StyledPaper>
  );
}
